import React from "react";
import { Link } from "react-router-dom";
import projectImg1 from "../img/Screenshot 2022-06-09 at 4.06.47 PM.png";
import projectImg3 from "../img/Screenshot 2022-06-09 at 4.08.34 PM.png";
import projectImg2 from "../img/Screenshot 2022-06-09 at 4.07.59 PM.png";

const Projects = () => {
  return (
    <div className="hero bg-gradient-to-r from-slate-200 to-red-200">
      <div className="hero-content text-center flex flex-col">
        <h1 className="font-bold">Projects I've worked on</h1>

        <div className="flex flex-col lg:flex-row lg:gap-10">
          <div className=" mt-10 w-full flex flex-col lg:flex-row flex-wrap gap-3 items-center">
            <div className="card w-80 glass">
              <figure>
                <img src={projectImg1} alt="car!" />
              </figure>
              <div className="card-body">
                <h2 className="card-title">Alok Tools web app</h2>

                <div className="card-actions justify-start">
                  <Link to="/project1">
                    <button className="btn btn-primary">Details</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className=" mt-10 w-full flex flex-col lg:flex-row flex-wrap gap-3 items-center">
            <div className="card w-80 glass">
              <figure>
                <img src={projectImg2} alt="car!" />
              </figure>
              <div className="card-body">
                <h2 className="card-title">Warehouse web app</h2>

                <div className="card-actions justify-start">
                  <Link to="/project2">
                    <button className="btn btn-primary">Details</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className=" mt-10 w-full flex flex-col lg:flex-row flex-wrap gap-3 items-center">
            <div className="card w-80 glass">
              <figure>
                <img src={projectImg3} alt="car!" />
              </figure>
              <div className="card-body">
                <h2 className="card-title">Independent service </h2>

                <div className="card-actions justify-start">
                  <Link to="/project3">
                    <button className="btn btn-primary">Details</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
